import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import {
  requestMakeDecisionClaim,
  requestSearchClaimInfo,
} from 'containers/OpeningClaimPageManager/actions';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import { PAGES } from 'routes';
import routesHelper, { pushTo } from 'containers/services/routes-helper';
import {
  makeSelectClaimNumber,
  makeSelectListings,
  makeSelectNotification,
} from 'containers/AppContainer/selectors';
import { Listings } from 'containers/AppContainer/typings';
import { setClaim } from 'containers/PreOpeningPage/actions';
import { makeSelecClaimToPreopen } from 'containers/PreOpeningPage/selectors';
import {
  makeSelectedClaims,
  makeSelectSearchClaims,
} from 'containers/IdentificationPage/selectors';

import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import ConversionClaimManager from 'containers/ConvertClaimOpeningManager/ConversionClaimManager';
import { setUploadDocument } from 'containers/UploadDocumentsManager/actions';
import { requestNotificationOpeningManagerMixedClaim } from 'containers/AppContainer/actions';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { DECISION_METERIAL_CLAIM } from 'containers/OpeningClaimPageManager/constants';
import { CLAIM_TYPE } from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/constants';
import { makeSelectSearchClaimInfo } from 'containers/OpeningClaimPageManager/selector';
import { resetStore } from 'containers/OpeningClaimPageManager/actions';
import { GLOBAL_STATUS } from 'services/constants';

export interface ConvertClaimOpeningManagerProps {
  intl: IntlShape;
  listings: Listings;
  setClaim: Function;
  storedClaimToPreopen: any;
  policyInfo: { sagis: {}; lossDate: Date };
  selectedClaim: any;
  corporealLawyers: any;
  requestSearchClaimInfo: Function;
  claimNumber: string;
  notification: any;
  requestMakeDecisionClaim: Function;
  setUploadDocument: Function;
  requestNotificationOpeningManagerMixedClaim: Function;
  resetSearchClaimsStore: Function;
  claimInfo: any;
  resetStore: Function;
}

export const ConvertClaimOpeningManager: React.FC<ConvertClaimOpeningManagerProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStore();
    };
  }, []);

  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStore();
    };
  }, []);

  const failedCallBack = () => {
    routesHelper.pushTo(PAGES.MANAGER_HOME)();
  };

  useEffect(() => {
    if (props.claimNumber) {
      props.requestSearchClaimInfo(props.claimNumber, failedCallBack);
    } else {
      routesHelper.pushTo(PAGES.MANAGER_HOME)();
    }
  }, [props.claimNumber]);
  useEffect(() => {
    if (get(props.notification, 'nature') === 'MIXTE') {
      const riskCorporealSagis = get(props.policyInfo, `sagis.claims`, [])
        .filter((el: any) => el.code === props.claimNumber)
        .find((el: any) => el.riskName === RISK_NAME.CORPOREAL);
      const claimCorporealSagis = get(
        props.claimInfo,
        `data.sagis.claims`,
        [],
      ).find((el: any) => el.claimType === CLAIM_TYPE.CORPOREL);
      if (!isEmpty(get(props.policyInfo, 'corporeal', []))) {
        toast.error(
          translate({ ...messages.claimOpenTitle }, props, {
            claimNumber: get(props.policyInfo, 'corporeal.[0].claimNumber', ''),
          }),
        );
        props.requestMakeDecisionClaim(
          {
            decision: DECISION_METERIAL_CLAIM.ACCEPTED,
            nature: get(props.notification, 'nature'),
            reason: 'CORPO RISK ALREADY EXIST IN BAWABA',
            claimNumber: props.claimNumber,
            id: get(props.notification, 'id'),
            status: GLOBAL_STATUS.VALIDATED,
            treated: true,
            claimId: get(props.policyInfo, 'corporeal.[0].id', ''),
            treatedBy: get(currentUserStorage.get(), 'username', ''),
          },
          () => {
            pushTo(PAGES.MANAGER_HOME)();
            props.resetSearchClaimsStore();
            props.resetStore();
          },
        );
      } else if (claimCorporealSagis && !isEmpty(claimCorporealSagis)) {
        toast.error(
          translate({ ...messages.otherClaimOpenSagisTitle }, props, {
            claimNumber: props.claimNumber,
          }),
        );
        props.requestMakeDecisionClaim(
          {
            decision: DECISION_METERIAL_CLAIM.ACCEPTED,
            nature: get(props.notification, 'nature'),
            reason: 'CORPO CLAIM ALREADY EXIST IN SAGIS',
            claimNumber: props.claimNumber,
            id: get(props.notification, 'id'),
            status: GLOBAL_STATUS.VALIDATED,
            treated: true,
            treatedBy: get(currentUserStorage.get(), 'username', ''),
          },
          () => {
            pushTo(PAGES.MANAGER_HOME)();
            props.resetSearchClaimsStore();
            props.resetStore();
          },
        );
      } else if (!isEmpty(riskCorporealSagis)) {
        toast.error(
          translate({ ...messages.claimOpenSagisTitle }, props, {
            claimNumber: props.claimNumber,
          }),
        );
        props.requestMakeDecisionClaim(
          {
            decision: DECISION_METERIAL_CLAIM.ACCEPTED,
            nature: get(props.notification, 'nature'),
            reason: 'CORPO RISK ALREADY EXIST IN SAGIS',
            claimNumber: props.claimNumber,
            id: get(props.notification, 'id'),
            status: GLOBAL_STATUS.VALIDATED,
            treated: true,
            treatedBy: get(currentUserStorage.get(), 'username', ''),
          },
          () => {
            pushTo(PAGES.MANAGER_HOME)();
            props.resetSearchClaimsStore();
            props.resetStore();
          },
        );
      }
    }
  }, [
    props.policyInfo,
    props.notification,
    props.claimNumber,
    props.claimInfo,
  ]);

  return (
    <div>
      <ConversionClaimManager
        listings={props.listings}
        setClaim={props.setClaim}
        storedClaimToPreopen={props.storedClaimToPreopen}
        policyInfo={props.policyInfo}
        selectedClaim={props.selectedClaim}
        corporealLawyers={props.corporealLawyers}
        requestSearchClaimInfo={props.requestSearchClaimInfo}
        claimNumber={props.claimNumber}
        notification={props.notification}
        requestMakeDecisionClaim={props.requestMakeDecisionClaim}
        setUploadDocument={props.setUploadDocument}
        requestNotificationOpeningManagerMixedClaim={
          props.requestNotificationOpeningManagerMixedClaim
        }
      />
    </div>
  );
};

const mapDispatchToProps = {
  setClaim,
  requestSearchClaimInfo,
  requestMakeDecisionClaim,
  setUploadDocument,
  requestNotificationOpeningManagerMixedClaim,
  resetSearchClaimsStore,
  resetStore,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  storedClaimToPreopen: makeSelecClaimToPreopen(),
  policyInfo: makeSelectSearchClaims(),
  selectedClaim: makeSelectedClaims(),
  corporealLawyers: makeSelectCorporealLawyers(),
  claimNumber: makeSelectClaimNumber(),
  notification: makeSelectNotification(),
  claimInfo: makeSelectSearchClaimInfo(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConvertClaimOpeningManager));
